import React, { useEffect } from "react";
import "./AccountContactsDetails.less";
import { Link, useHistory, useParams } from "react-router-dom";
import { Breadcrumb, Spin } from "antd";
import { useAppDispatch, useAppSelector } from "../../../index";
import { getIndividualInfoById } from "../../../store/slices/accountsTs";
import { AccountContactsDetailsPersonal } from "./AccountContactsDetailsPersonal/AccountContactsDetailsPersonal";
import { AccountContactsDetailsPosition } from "./AccountContractsDetailsPosition/AccountContractsDetailsPosition";
import { AccountContractsDetailsEmails } from "./AccountContractsDetailsEmails/AccountContractsDetailsEmails";
import { AccountContractsDetailsPhone } from "./AccountContactsDetailsPhone/AccountContactsDetailsPhone";
import { AccountContractsDetailsAddress } from "./AccountContactsDetailsAddress/AccountContactsDetailsAddress";
import { fetchRegions } from "../../../store/slices/dicts";
import { checkIsLoading } from "../../../lib/utils";

export const AccountContactsDetails = () => {
  const history = useHistory();
  const { accountId } = useParams<{ accountId: string }>();
  const individualId = history.location.search.substring(1).split("=")[1];
  const { getIndividualByIdLoading } = useAppSelector((state) => state.accountsTs);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getIndividualInfoById({ individualId }));
    dispatch(fetchRegions());
  }, []);

  return (
    <div className="account-contacts-details-container">
      {checkIsLoading(getIndividualByIdLoading) && <Spin className="spin custom-spin" />}
      <Breadcrumb className="breadcrumb" style={{ marginTop: "10px" }}>
        <Breadcrumb.Item>
          <Link to={`/accounts/${accountId}/info/contacts`}>Контактные лица</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Детали контактного лица</Breadcrumb.Item>
      </Breadcrumb>
      <h2 style={{ marginTop: "10px" }}>Детали контактного лица</h2>
      <AccountContactsDetailsPersonal />
      <AccountContactsDetailsPosition />
      <AccountContractsDetailsEmails />
      <AccountContractsDetailsPhone />
      <AccountContractsDetailsAddress />
    </div>
  );
};
